import { BrowserModule } from "@angular/platform-browser";
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HttpClientModule, HTTP_INTERCEPTORS } from "@angular/common/http";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { AppRoutingModule } from "./app-routing.module";
import { AppComponent } from "./app.component";
import { SideBarComponent } from "./components/side-bar/side-bar.component";
import { AuthComponent } from "./components/auth/auth.component";
import { HomeComponent } from "./components/home/home.component";
import { AuthService } from "./components/auth/auth.service";
import { DropdownModule } from "primeng/dropdown";
import { HomeService } from "./components/home/home.services";
import { NgHttpLoaderModule } from "ng-http-loader";
import { TabViewModule } from "primeng/tabview";
import { TableModule } from "primeng/table";
import { AccordionModule } from "primeng/accordion";
import { PaginatorModule } from 'primeng/paginator';
import { DialogModule } from 'primeng/dialog';
import { CalendarModule } from 'primeng/calendar';
import { CustomDatePipe } from "./core/utils/custompipes";
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { MultiSelectModule } from 'primeng/multiselect';
import { InputSwitchModule } from 'primeng/inputswitch';
import { TagModule } from 'primeng/tag';

// import { AppHttpInterceptor } from './core/app-http.interceptor';
// import { AuthService as CoreAuthService } from './core/services/auth.service';

// import {MatProgressSpinnerModule} from '@angular/material/progress-spinner';

// import { MessagesModule } from 'primeng/messages';
// import { MessageModule } from 'primeng/message';
// // import { ToastModule } from 'primeng/toast';

import {
  ObjecttoKeyvalue,
  ArrayChk,
  TableChk,
  ArrayChkLength,
  TableHeaders,
  TableBody,
  OrderByPipe,
  ObjectChk,
  StringCheckPipe,
  ArrayChkWithString,
} from "./core/utils/custompipes";
import { RegTableComponent } from "./components/costing-page/reg-table/reg-table.component";
import { CostingPageComponent } from "./components/costing-page/costing-page.component";
import { CostingPageService } from "./components/costing-page/costing-page.service";
import { ApiCostingtableComponent } from "./components/costing-page/api-costingtable/api-costingtable.component";
import { BeStudyCostingComponent } from "./components/costing-page/be-study-costing/be-study-costing.component";
import { PopupComponent } from "./shared/directives/popup/popup.component";
import { ExcelUploadComponent } from "./components/admin/excel-upload/excel-upload.component";
import { SharedModule } from "./shared/shared.module";
import { DatadirectoryComponent } from "./components/data-directory/datadirectory.component";
import { InvestmentCostingComponent } from "./components/costing-page/investment-costing/investment-costing.component";
import { SettingsComponent } from "./components/settings/settings.component";
import { UserOwnSettingComponent } from "./components/user-own-setting/user-own-setting.component";
import { SettingsService } from "./components/settings/settings.service";
import { BusinessCaseComponent } from "./components/settings/business-case/business-case.component";
import { BusinessCaseSettingComponent } from "./components/user-own-setting/business-case-setting/business-case-setting.component";
import { ToastrModule } from "ngx-toastr";
import { UserFormComponent } from "./components/user-form/user-form.component";
import { PatentInfoComponent as HomePatentInfo } from "./components/home/patent-info/patent-info.component";
import { LitigationInformationComponent as HomeLitigationInfo } from "./components/home/litigation-information/litigation-information.component";

import { RegulatoryInfoComponent as HomeRegularInfo } from "./components/home/regulatory-info/regulatory-info.component";
import { ExecutiveSummaryComponent as HomeExecutiveSummary } from "./components/home/executive-summary/executive-summary.component";
import { ClinicalInfoComponent as HomeClinicalInfo } from "./components/home/clinical-info/clinical-info.component";
import { CompetitiveIntelligenceComponent as HomeCompetitive } from "./components/home/competitive-intelligence/competitive-intelligence.component";
import { CostingInfoComponent as HomeCosting } from "./components/home/costing-info/costing-info.component";
import { ApiInfoComponent as HomeApiInfo } from "./components/home/api-info/api-info.component";
import { FormulationInfoComponent as HomeFormulation } from "./components/home/formulation-info/formulation-info.component";
import { UploadFilesComponent } from "./components/upload-files/upload-files.component";
import { ReportsComponent } from "./components/reports/reports.component";
import { SignUpComponent } from "./components/auth/sign-up/sign-up.component";
import { CostingPageNewComponent } from "./components/costing-page-new/costing-page-new.component";
import { EstCalculationComponent } from "./components/est-calculation/est-calculation.component";
import { ErrorListComponent } from "./components/error-list/error-list.component";
import { CommercialIntelligenceComponent } from "./components/commercial-intelligence/commercial-intelligence.component";
import { SalesVolumeComponent } from "./components/sales-volume/sales-volume.component";
import { FileuploadComponent } from "./components/fileupload/fileupload.component";
import { FilessalesandvolumeComponent } from "./components/filessalesandvolume/filessalesandvolume.component";
import { UserregisterComponent } from "./components/userregister/userregister.component";
import { LifecycleintellegenceComponent } from "./components/lifecycleintellegence/lifecycleintellegence.component";
import { PatentInfoComponent as LifePatent } from "./components/lifecycleintellegence/patent-info/patent-info.component";
import { RegulatoryInfoComponent as LifeRegulator } from "./components/lifecycleintellegence/regulatory-info/regulatory-info.component";
import { ExecutiveSummaryComponent as LifeExecutive } from "./components/lifecycleintellegence/executive-summary/executive-summary.component";
import { ClinicalInfoComponent as LifeClinicaInfo } from "./components/lifecycleintellegence/clinical-info/clinical-info.component";
import { CompetitiveintellegenceComponent as LifeCompetitive } from "./components/lifecycleintellegence/competitiveintellegence/competitiveintellegence.component";
import { CostingInfoComponent as LifeCosting } from "./components/lifecycleintellegence/costing-info/costing-info.component";
import { ApiInfoComponent as LifeApiInfo } from "./components/lifecycleintellegence/api-info/api-info.component";
import { FormulationInfoComponent as LifeFormulation } from "./components/lifecycleintellegence/formulation-info/formulation-info.component";
import { LifecycleintellegenceService } from "./components/lifecycleintellegence/lifecycleintellegence.service";
import { ScrapingupdateComponent } from './components/scrapingupdate/scrapingupdate.component';
import { LogmanagementComponent } from './components/logmanagement/logmanagement.component';
import { BusinesscaseComponent } from './components/businesscase/businesscase.component';
import { ErrorDashboardComponent } from './components/error-dashboard/error-dashboard.component';
import { IrrComponent } from './components/error-dashboard/irr/irr.component';
import { IrrNpvComponent } from './components/error-dashboard/irr-npv/irr-npv.component';
import { NewsalesandvolumeComponent } from './components/error-dashboard/newsalesandvolume/newsalesandvolume.component';
import { AnticipatedDateComponent } from './components/error-dashboard/anticipated-date/anticipated-date.component';
import { NewcostingComponent } from './components/error-dashboard/newcosting/newcosting.component';
import { CostingcheckerComponent } from './components/error-dashboard/costingchecker/costingchecker.component';
import { UploadtoliveComponent } from './components/uploadtolive/uploadtolive.component';
import { UserRegistrationComponent } from './components/user-registration/user-registration.component';
import { RequestTrainingComponent } from './components/request-training/request-training.component';
import { ProductDashboardComponent } from './components/product-dashboard/product-dashboard.component';
import { AllRldComponent } from './components/error-dashboard/all-rld/all-rld.component';
import { ExcelManagerComponent } from './components/excel-manager/excel-manager.component';
import { LitigationDashboardComponent } from './components/litigation-dashboard/litigation-dashboard.component';
import { NewCostingComponent } from "./components/new-costing/new-costing.component";
import { NewApiCostingComponent } from "./components/new-costing/new-api-costing/new-api-costing.component";
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { RightsWiseLoginComponent } from "./components/rights-wise-login/rights-wise-login.component";
import { LitigationComplaintsComponent } from "./components/litigation-complaints/litigation-complaints.component";
import { ViewAllLitigationComplaintsComponent } from "./components/view-all-litigation-complaints/view-all-litigation-complaints.component";
import { SubscriberEmailComponent } from "./components/subscriber-email/subscriber-email.component";
import { NgxSummernoteModule } from 'ngx-summernote';
import { CustomerLogsComponent } from "./components/customer-logs/customer-logs.component";
import { SubscriberMailUsersComponent } from "./components/subscriber-mail-users/subscriber-mail-users.component";
import { NewSubscriberMailComponent } from "./components/new-subscriber-mail/new-subscriber-mail.component";
import { FieldReviewDashboardComponent } from "./components/field-review-dashboard/field-review-dashboard.component";
import { BusinessCaseDisplayComponent } from "./components/business-case-display/business-case-display.component";
import { SaleVolumeCompareComponent } from "./sale-volume-compare/sale-volume-compare.component";
import { GetMostSearchedComponent } from "./get-most-searched/get-most-searched.component";
import { CompanyMasterComponent } from "./components/company-master/company-master.component";
import { ProductStatusDashboardComponent } from "./components/product-status-dashboard/product-status-dashboard.component";
import { BusinesscaseStatusDashboardComponent } from "./components/businesscase-status-dashboard/businesscase-status-dashboard.component";
import { PatentExpirationComponent } from "./components/error-dashboard/patent-expiration/patent-expiration.component";
import { ExcelDumpDashboardComponent } from "./components/excel-dump-dashboard/excel-dump-dashboard.component";
import { PadufaComponent } from "./components/padufa/padufa.component";
import { CalendarViewComponent } from "./components/padufa/calenderview/calenderview.component";
import { TypeSelectionComponent } from "./components/padufa/type-selection/type-selection.component";
import { CategorySelectionComponent } from "./components/padufa/category-selection/category-selection.component";
import { TherapeuticSelectionComponent } from "./components/padufa/therapeutic-selection/therapeutic-selection.component";
import { ResultsComponent } from "./components/padufa/results/results.component";
import { DrugModalComponent } from "./components/padufa/drug-modal/drug-modal.component";
import { BreadcrumbComponent } from "./components/padufa/breadcrumb/breadcrumb.component";
import { PeakSaleComponent } from "./components/peak-sale/peak-sale.component";
import { CategoryParserPipe } from "./shared/categoryParser.pipe";
import { ImportantUpdatesComponent } from "./components/important-updates/important-updates.component";
import { LitigationEventsComponent } from "./components/error-dashboard/litigation-events/litigation-events.component";
import { AppealEventsComponent } from "./components/error-dashboard/appeal-events/appeal-events.component";
import { SectionWiseEmailComponent } from "./components/section-wise-email/section-wise-email.component";
import { LmsDsManualEntryComponent } from "./components/lms-ds-manual-entry/lms-ds-manual-entry.component";
import { PushToLiveComponent } from "./components/push-to-live/push-to-live.component";
import { PteEventsComponent } from "./components/pte-events/pte-events.component";
import { ShortagePanelComponent } from "./components/shortage-panel/shortage-panel.component";
import { UploadShortageFileComponent } from "./components/upload-shortage-file/upload-shortage-file.component";
import { ShortageOverviewComponent } from "./components/shortage-panel/shortage-overview/shortage-overview.component";
import { ShortageChangelogComponent } from "./components/shortage-panel/shortage-changelog/shortage-changelog.component";
import { ShortageRecoveryPanelComponent } from "./components/shortage-panel/shortage-recovery-panel/shortage-recovery-panel.component";
import { ShortageCommentsComponent } from "./components/shortage-panel/shortage-comments/shortage-comments.component";
import { ShortageExplorerComponent } from "./components/shortage-panel/shortage-explorer/shortage-explorer.component";

@NgModule({
  declarations: [
    AppComponent,
    SideBarComponent,
    AuthComponent,
    SignUpComponent,
    HomeComponent,
    ObjecttoKeyvalue,
    ArrayChk,
    ArrayChkLength,
    ArrayChkWithString,
    TableChk,
    TableHeaders,
    TableBody,
    OrderByPipe,
    CategoryParserPipe,
    ObjectChk,
    StringCheckPipe,
    RegTableComponent,
    CostingPageComponent,
    ApiCostingtableComponent,
    BeStudyCostingComponent,
    InvestmentCostingComponent,
    PopupComponent,
    ExcelUploadComponent,
    DatadirectoryComponent,
    BusinessCaseComponent,
    BusinessCaseSettingComponent,
    BusinessCaseDisplayComponent,
    SettingsComponent,
    UserOwnSettingComponent,
    UserFormComponent,
    HomePatentInfo,
    HomeLitigationInfo,
    HomeRegularInfo,
    HomeClinicalInfo,
    HomeApiInfo,
    HomeExecutiveSummary,
    HomeCosting,
    UploadFilesComponent,
    ReportsComponent,
    CostingPageNewComponent,
    EstCalculationComponent,
    ErrorListComponent,
    CommercialIntelligenceComponent,
    SalesVolumeComponent,
    SaleVolumeCompareComponent,
    FileuploadComponent,
    FilessalesandvolumeComponent,
    UserregisterComponent,
    LifecycleintellegenceComponent,
    LifePatent,
    LifeRegulator,
    LifeExecutive,
    LifeClinicaInfo,
    LifeCosting,
    LifeApiInfo,
    HomeFormulation,
    HomeCompetitive,
    UploadFilesComponent,
    ReportsComponent,
    LifeCompetitive,
    LifeFormulation,
    ScrapingupdateComponent,
    LogmanagementComponent,
    PadufaComponent,
    BusinesscaseComponent,
    BusinessCaseDisplayComponent,
    ErrorDashboardComponent,
    IrrComponent,
    IrrNpvComponent,
    NewsalesandvolumeComponent,
    AnticipatedDateComponent,
    NewcostingComponent,
    CostingcheckerComponent,
    CustomDatePipe,
    UploadtoliveComponent,
    UserRegistrationComponent,
    RequestTrainingComponent,
    ProductDashboardComponent,
    AllRldComponent,
    ExcelManagerComponent,
    LitigationDashboardComponent,
    NewCostingComponent,
    NewApiCostingComponent,
    RightsWiseLoginComponent,
    LitigationComplaintsComponent,
    ViewAllLitigationComplaintsComponent,
    CompanyMasterComponent,
    GetMostSearchedComponent,
    SubscriberEmailComponent,
    CustomerLogsComponent,
    SubscriberMailUsersComponent,
    NewSubscriberMailComponent,
    FieldReviewDashboardComponent,
    ProductStatusDashboardComponent,
    BusinesscaseStatusDashboardComponent,
    PatentExpirationComponent,
    ExcelDumpDashboardComponent,
    CalendarViewComponent,
    TypeSelectionComponent,
    CategorySelectionComponent,
    TherapeuticSelectionComponent,
    ResultsComponent,
    DrugModalComponent,
    BreadcrumbComponent,
    PeakSaleComponent,
    ImportantUpdatesComponent,
    LitigationEventsComponent,
    AppealEventsComponent,
    SectionWiseEmailComponent,
    LmsDsManualEntryComponent,
    PushToLiveComponent,
    PteEventsComponent,
    ShortagePanelComponent,
    UploadShortageFileComponent,
    ShortageOverviewComponent,
    ShortageChangelogComponent,
    ShortageRecoveryPanelComponent,
    ShortageCommentsComponent,
    ShortageExplorerComponent
  ],
  imports: [
    FormsModule,
    AccordionModule,
    SharedModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AccordionModule,
    HttpClientModule,
    BrowserModule,
    AppRoutingModule,
    DropdownModule,
    TabViewModule,
    TableModule,
    ToastrModule.forRoot({
      timeOut: 10000,
    }),
    NgHttpLoaderModule,
    PaginatorModule,
    DialogModule,
    CalendarModule,
    ConfirmDialogModule,
    CKEditorModule,
    MultiSelectModule,
    NgxSummernoteModule,
    InputSwitchModule,
    TagModule
  ],
  providers: [
    AuthService,
    // { provide: CoreAuthService },
    // { provide: ComponentAuthService },
    HomeService,
    LifecycleintellegenceService,
    CostingPageService,
    SettingsService,
    // {
    //   provide: HTTP_INTERCEPTORS,
    //   useClass: AppHttpInterceptor,
    //   multi: true
    // }
  ],
  bootstrap: [AppComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class AppModule { }